import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { closePack, openPack } from '../data/pack-store';
import { ghEntryFromSearch, normalizePackInput, parseGhArtifact } from './resolve';
import { writePackParam } from './url-sync';

/**
 * Return to the landing screen (standalone only): clear every URL coordinate
 * (?pack and the view params) so a reload stays home, then reset the store.
 * Wired to the header brand / "Evidence" crumb.
 */
export function goHome() {
  var _window$history;
  if (typeof window !== 'undefined' && (_window$history = window.history) !== null && _window$history !== void 0 && _window$history.replaceState) {
    window.history.replaceState(window.history.state, '', window.location.pathname);
  }
  void closePack();
}

/** Single entry point for every way a pack arrives (URL param, typed URL,
 * dropped/picked File, gh-artifact: pseudo-scheme / GitHub artifact link). */
export function openPackFromInput(input) {
  if (typeof input === 'string') {
    var url = normalizePackInput(input);
    // Reflect it in ?pack= — the view params (?tab/?test/…) written while
    // browsing would otherwise produce a URL that LOOKS like a deep link
    // but reloads to the picker. File-opened packs have no URL to write;
    // their view params stay session-only by nature.
    writePackParam(url);
    var gh = parseGhArtifact(url);
    if (gh) {
      var _ghEntryFromSearch;
      // ?ghEntry= (chooser pick / deep link) selects one pack from a
      // multi-pack artifact; absent → sole pack opens, or the chooser shows.
      var entry = (_ghEntryFromSearch = ghEntryFromSearch(window.location.search)) !== null && _ghEntryFromSearch !== void 0 ? _ghEntryFromSearch : undefined;
      void openPack(_objectSpread(_objectSpread({
        kind: 'gh-artifact'
      }, gh), {}, {
        entry: entry
      }));
    } else {
      void openPack({
        kind: 'url',
        url: url
      });
    }
  } else {
    void openPack({
      kind: 'file',
      file: input
    });
  }
}